import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";

import H1 from "../../../Components/Titles/H1";
import axios from "axios";
import { Input, Alert, Table, Button, Tag } from "antd";
import { DownOutlined, SearchOutlined, UpOutlined } from "@ant-design/icons";
import { ADMIN_GET_COMPANIES_SEARCH } from "../../../constants/api";
import { R_ADD_COMPANIES } from "../../../constants/routes";
import ModalAddJourneys from "../../../Components/Modais/ModalAddJourneys/ModalAddJourneys";
import ButtonActions from "../../../Components/Buttons/ButtonActions/ButtonActions";
import { getCurrentUser, fetchAuthSession } from "@aws-amplify/auth";
import moment from "moment";
import classes from "./RegisteredCompanies.module.scss";

const { Search } = Input;

const getSearchErrorMessage = (status) => {
  switch (status) {
    case 400:
      return "Informe um termo de busca válido.";
    case 404:
      return "Nenhuma informação encontrada para essa busca.";
    default:
      return "Erro interno ao buscar empresas. Tente novamente.";
  }
};

const SuperAdminsCell = ({ admins }) => {
  const [expanded, setExpanded] = useState(false);

  if (!admins || admins.length < 1) return "-";

  const visible = admins.slice(0, 2);
  const hidden = admins.slice(2);

  return (
    <div className={classes.SuperAdminsCell}>
      {visible.map((admin) => (
        <Tag key={admin} className={classes.AdminTag}>
          {admin}
        </Tag>
      ))}
      {hidden.length > 0 && !expanded && (
        <Button
          size="small"
          className={classes.ExpandButton}
          onClick={() => setExpanded(true)}
        >
          <DownOutlined />
        </Button>
      )}
      {expanded &&
        hidden.map((admin) => (
          <Tag key={admin} className={classes.AdminTag}>
            {admin}
          </Tag>
        ))}
      {expanded && hidden.length > 0 && (
        <Button
          size="small"
          className={classes.ExpandButton}
          onClick={() => setExpanded(false)}
        >
          <UpOutlined />
        </Button>
      )}
    </div>
  );
};

const RegisteredCompanies = () => {
  const history = useHistory();
  const [state, setState] = useState({
    error: "",
    progress: 0,
    users: [],
    all_users: [],
    user_email: "",
    user_sub: "",
    product_name: "",
    modal_visible: false,
    modal_visible_free: false,
    loading: false,
    mensagem: 0,
    message_no_user: false,
    change_plan: false,
  });
  const [showModalAddJourney, setShowModalAddJourney] = useState(false);
  const [getCompany, setGetCompany] = useState();
  const [companyUid, setCompanyUid] = useState("");
  const [planPermission, setPlanPermission] = useState("");
  const [currentUsersGo, setCurrentUsersGo] = useState(0);
  const [currentUsersSmart, setCurrentUsersSmart] = useState(0);
  const [notFoundMessage, setNotFoundMessage] = useState("");
  const [hasSearched, setHasSearched] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const searchInputRef = useRef(null);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        searchInputRef.current?.focus();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  const searchUserByEmailAndCompany = (search) => {
    setState({ loading: true, error: "" });
    getCurrentUser().then(async (u) => {
      const session = await fetchAuthSession({
        forceRefresh: true
      });
      const userToken = session.tokens?.idToken?.toString();

      axios
        .get(ADMIN_GET_COMPANIES_SEARCH(search), {
          headers: {
            Authorization: userToken,
          },
        })
        .then((users) => {
          setGetCompany(users.data);
          if (Object.keys(users.data).length > 0) {
            setNotFoundMessage("");
            setState({
              ...state,
              users: users.data,
              error: "",
              loading: false,
              message_no_user: false,
            });
          } else {
            setNotFoundMessage(getSearchErrorMessage(404));
            setState({ error: "", loading: false });
          }
        })
        .catch((e) => {
          const status = e?.response?.status;
          if (status === 404) {
            setGetCompany([]);
            setNotFoundMessage(getSearchErrorMessage(404));
            setState({ error: "", loading: false });
            return;
          }
          setNotFoundMessage("");
          setState({
            error: getSearchErrorMessage(status),
            loading: false,
          });
        });
    });
  };

  const handleSearch = (value) => {
    const trimmed = value?.trim();
    if (!trimmed) {
      return;
    }
    setHasSearched(true);
    searchUserByEmailAndCompany(trimmed);
  };

  const handleJourneyUpdated = ({ netSmart, netGo }) => {
    setGetCompany((prev) =>
      prev.map((company) =>
        company.company_uid === companyUid
          ? {
              ...company,
              limit_users: (company.limit_users || 0) + netGo,
              limit_users_smart: (company.limit_users_smart || 0) + netSmart,
            }
          : company
      )
    );
  };

  const topAlignedCell = () => ({ style: { verticalAlign: "top" } });

  const columns = [
    {
      title: "#",
      key: "index",
      align: "center",
      onCell: topAlignedCell,
      render: (_, __, index) => index,
    },
    {
      title: "Código Empresa",
      dataIndex: "company_uid",
      key: "company_uid",
      align: "center",
      onCell: topAlignedCell,
    },
    {
      title: "Nome Empresa",
      dataIndex: "company_name",
      key: "company_name",
      align: "center",
      onCell: topAlignedCell,
    },
    {
      title: "Tipo de Plano",
      dataIndex: "plan_name",
      key: "plan_name",
      align: "center",
      onCell: topAlignedCell,
    },
    {
      title: "Super Admins",
      key: "super_admins",
      align: "center",
      onCell: topAlignedCell,
      render: (_, record) => <SuperAdminsCell admins={record?.super_admin} />,
    },
    {
      title: "N° Usuários Go",
      dataIndex: "limit_users",
      key: "limit_users",
      align: "center",
      onCell: topAlignedCell,
    },
    {
      title: "N° Usuários Smart",
      dataIndex: "limit_users_smart",
      key: "limit_users_smart",
      align: "center",
      onCell: topAlignedCell,
    },
    {
      title: "Empresa Ativa",
      key: "active",
      align: "center",
      onCell: topAlignedCell,
      render: (_, record) => (record?.active === 1 ? "Sim" : "Não"),
    },
    {
      title: "Data de Criação",
      key: "date_created",
      align: "center",
      onCell: topAlignedCell,
      render: (_, record) => moment(record?.date_created).format("DD/MM/YYYY"),
    },
    {
      title: "Gerenciar Triagens",
      key: "add_journey",
      align: "center",
      onCell: topAlignedCell,
      render: (_, record) => (
        <ButtonActions
          variant="primary"
          text="GERENCIAR"
          className={classes.ButtonManageJourneys}
          onClick={() => {
            setShowModalAddJourney(true);
            setCompanyUid(record?.company_uid);
            setPlanPermission(record?.plan_permission);
            setCurrentUsersGo(record?.limit_users || 0);
            setCurrentUsersSmart(record?.limit_users_smart || 0);
          }}
        />
      ),
    },
  ];

  const tableData =
    getCompany && Object.keys(getCompany).length > 0
      ? [...getCompany].sort((a, b) => b.id - a.id)
      : [];

  return (
    <>
      <div>
        <H1>EMPRESAS CADASTRADAS</H1>
        {showModalAddJourney && (
          <ModalAddJourneys
            setShowModalAddJourney={setShowModalAddJourney}
            onJourneyUpdated={handleJourneyUpdated}
            companyUid={companyUid}
            planPermission={planPermission}
            currentUsersGo={currentUsersGo}
            currentUsersSmart={currentUsersSmart}
          />
        )}
        <div className={classes.Toolbar}>
          <div>
            <Search
              ref={searchInputRef}
              id={"search"}
              placeholder="Nome, código, plano ou email"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              onSearch={handleSearch}
              size="large"
              className={classes.SearchInput}
              loading={state.loading}
              enterButton={
                <Button disabled={!searchValue.trim()} icon={<SearchOutlined />} />
              }
            />
            {state.error && <Alert message={state.error} type="warning" />}
          </div>
          <ButtonActions
            variant="primary"
            text="adicionar empresa"
            onClick={() => history.push(R_ADD_COMPANIES)}
          />
        </div>
        {hasSearched && (
          <div className={classes.DataTable}>
            <Table
              columns={columns}
              dataSource={tableData}
              rowKey="company_uid"
              pagination={false}
              loading={state.loading}
              locale={{
                emptyText: notFoundMessage || "Nenhuma empresa cadastrada.",
              }}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default RegisteredCompanies;
